import { getTeamLabelByNumber } from '../../utils/utils'

export default {
  // 'this' - $store
  byActionType: {},
  // 'this' - $store
  byEventType: {
    'PLAYER_WITHDRAWAL' ({ TeamNumber }) {
      this.setPrematurelyGameFinish(TeamNumber)
    },
    'SET' (event) {
      const { ScoreHome, ScoreAway } = event

      this.setIngameProperty({
        property: 'sets',
        value: {
          home: ScoreHome,
          away: ScoreAway
        }
      })

      this.setIngameProperty({
        property: 'score',
        value: {
          home: 0,
          away: 0
        }
      })
    },
    'FINISH_GAME' (event) {
      const { TeamNumber } = event
      const { prematurelyGameOver } = this

      if (!prematurelyGameOver) {
        this.setWinnerMutation(getTeamLabelByNumber(TeamNumber))
        this.translationToArchive()

        return
      }

      const winner = prematurelyGameOver === 1 ? 2 : 1

      this.setWinnerMutation(getTeamLabelByNumber(winner))
      this.translationToArchive()
    }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
    /**
     * @return {string}
     */
    'FINISH_GAME' (event) {
      const {
        eventInfo: { title },
        TeamNumber
      } = event
      const {
        prematurelyGameOver,
        homeTeamTitle,
        awayTeamTitle
      } = this

      if (!TeamNumber) {
        return `${this.$t('trader.gameover')} / ${this.$t('trader.draw.capitalized')}`
      }

      if (!prematurelyGameOver) return `${title} / ${TeamNumber === 1 ? homeTeamTitle : awayTeamTitle}`

      return `${title} / ${prematurelyGameOver === 1 ? awayTeamTitle : homeTeamTitle}`
    },
    'ADJUST_POINTS' (event) {
      return this.$t('trader.adjust.points.title')
    },
    /**
     * @return {string}
     */
    'CANCEL' (event, relatedEvent) {
      const { homeTeamTitle, awayTeamTitle } = this
      const { eventInfo } = event
      const { title } = eventInfo
      const { EventCode, extra, TeamNumber } = relatedEvent
      const { team } = extra
      const notPointEvents = ['TIMEOUT', 'BALL_IN_GAME', 'FINISH_PERIOD']

      if (notPointEvents.includes(EventCode)) {
        return `${title}: ${this.getEventTitle(relatedEvent)}`
      }

      if (EventCode === 'POINT') {
        return `
          ${title}: 
          ${relatedEvent.eventInfo.title}, 
          ${extra[`points-${team}`]}, 
          ${TeamNumber === 1 ? homeTeamTitle : awayTeamTitle}
        `
      }

      return `${title}: ${this.getEventTitle(relatedEvent)}`
    }
  }
}
